import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { PrismicRichText, useAllPrismicDocumentsByType } from '@prismicio/react';
import  Treatment  from '../components/Treatment';

import '../assets/scss/treatment.scss';

const Treatments = ({ content }) => {
    const [treatmentsDocument, { state: treatmentsDocumentState }] = useAllPrismicDocumentsByType('treatment');
    if (treatmentsDocumentState === 'failed' || !treatmentsDocument || !treatmentsDocument.length) return <></>;

    return (
        <div className="treatments">
            <Container>
                {content && (
                    <PrismicRichText
                        field={content}
                    />
                )}
                    <Grid container spacing={2}>
                        {treatmentsDocument.map((treatment, index) => (
                             <Grid item xs={12} md={3} key={index}>
                                <Treatment
                                    title={treatment.data.title}
                                    description={treatment.data.description}
                                />
                           </Grid> 
                        ))} 
                    </Grid>
              
            </Container>
        </div>
    )
};
export default Treatments;